import { render, staticRenderFns } from "./aiAdminSetupExchangeCard.vue?vue&type=template&id=009f23d8&scoped=true"
import script from "./aiAdminSetupExchangeCard.vue?vue&type=script&lang=js"
export * from "./aiAdminSetupExchangeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009f23d8",
  null
  
)

export default component.exports